module.exports = __webpack_public_path__ + "img/momo_cta_button_redeemed.1236f53d.png";